export const ALLTENANTUSAGE = '/analytics/features'
export const ALLTENANTUSAGE_DOWNLOAD_CSV = '/analytics/features/download-csv'
export const TOP_FEATURES_MONTHLY = '/analytics/top-features-monthly'
export const TOP_TENANTS = '/analytics/top-tenants'
export const TOP_TENANTS_DOWNLOAD_CSV = '/analytics/top-tenants/download-csv'
export const RECENT_TENANTS = '/analytics/recent-tenants'
export const RECENT_TENANTS_DOWNLOAD_CSV = '/analytics/recent-tenants/download-csv'
export const RECENT_FEATURES = '/analytics/recent-features'
export const RECENT_FEATURES_DOWNLOAD_CSV = '/analytics/recent-features/download-csv'
export const RISKY_TENANTS = '/analytics/risky-tenants'
export const RISKY_TENANTS_DOWNLOAD_CSV = '/analytics/risky-tenants/download-csv'
export const RISKY_FEATURES = '/analytics/risky-features'
export const RISKY_FEATURES_DOWNLOAD_CSV = '/analytics/risky-features/download-csv'
export const OVERALL_FEATURE_COUNT ='/analytics/overall-feature-count'